import React from 'react'

import './VoteButtonsResult.scss'
/*

*/

const VoteButtonsResult = ({
  selected = null,
  upvotes = 0,
  downvotes = 0,
  totalResultsCount = 0,
  upVotetxt,
  downVotetxt,
}) => {
  // console.log(upVotetxt, downVotetxt)
  // prevent a devide by zero from bad input
  if (totalResultsCount == 0) {
    totalResultsCount = 1
  }

  return (
    <div className="results-graph">
      <div className="results-group">
        <div className={`item ${selected === 'UP' ? ' selected' : ''}`}>
          <div className="meter-and-value">
            <div className="meter">
              <span
                style={{ width: `${(upvotes / totalResultsCount) * 100}%` }}
              ></span>
            </div>
            <div className="label">
              {Math.round(
                Number.parseFloat((upvotes / totalResultsCount) * 100),
              )}
              %
            </div>
          </div>
          <div className="vote-result-text" dangerouslySetInnerHTML={{ __html: upVotetxt }}></div>
        </div>

        <div className={`item ${selected === 'DOWN' ? ' selected' : ''}`}>
          <div className="meter-and-value">
            <div className="meter">
              <span
                style={{ width: `${(downvotes / totalResultsCount) * 100}%` }}
              ></span>
            </div>
            <div className="label">
              {Math.round(
                Number.parseFloat((downvotes / totalResultsCount) * 100),
              )}
              %
            </div>
          </div>
          <div className="vote-result-text" dangerouslySetInnerHTML={{ __html: downVotetxt }}></div>
        </div>

        {/* <div className="results-single">
              <div className="results-count-bar">
                <span className={`results-count${pollResults.selected === 'UP' ? ' selected' : ''}`} style={{ width: `${pollResults.upvotes/pollResults.totalResultsCount * 100}%` }}></span>
              </div>
              <span className="results-percentage">{Math.round(Number.parseFloat(pollResults.upvotes/pollResults.totalResultsCount * 100))}%</span>
              <p className="results-answer" dangerouslySetInnerHTML={{__html: upVotetxt}}></p>
            </div>
            <div className="results-single">
              <div className="results-count-bar">
                <span className={`results-count${pollResults.selected === 'DOWN' ? ' selected' : ''}`} style={{ width: `${pollResults.downvotes/pollResults.totalResultsCount * 100}%` }}></span>
              </div>
              <span className="results-percentage">{Math.round(Number.parseFloat(pollResults.downvotes/pollResults.totalResultsCount * 100))}%</span>
              <p className="results-answer" dangerouslySetInnerHTML={{__html: downVotetxt}}></p>
            </div> */}
      </div>
    </div>
  )
}

export default VoteButtonsResult
